import Order, { CardOrder, OrderStatus } from "ts/api/order";
import { PaymentMethodType } from "ts/api/paymentMethod";
import getTransfers from "tools/order/getTransfers";
import { OrderReviewStatus, OrderReviewType } from "ts/api/orderReview";
import { mapOrderProduct } from "../../mapOrderProduct";
import { ComposeCardOrderParams } from "../types";

const composeCardOrder = async ({
  paymentType,
  products,
  standId,
  exhibitorId,
  billingDetails,
  totalAmount,
  organiser,
  show,
  transferredPaymentDescription,
  createdAt,
  isRequiredApproval,
  id,
  isQuick,
  allowBankTransfer,
  orderGroupId,
  exhibitorPairId,
}: ComposeCardOrderParams): Promise<CardOrder> => {
  const orderBase: Omit<
    CardOrder,
    "paymentDetails" | "products" | "transfers" | "organiserRevenue"
  > = {
    createdAt,
    paymentType,
    exhibitorId,
    standId,
    billingDetails,
    id,
    orderGroupId,
    ...(isQuick && { allowBankTransfer: !!allowBankTransfer }),
  };
  const transfers = await getTransfers({
    products,
    organiser,
    show,
    transferredPaymentDescription,
    orderId: id,
  });
  const organiserRevenue = transfers[0].amount;

  // eslint-disable-next-line @typescript-eslint/ban-types
  const review: Order["review"] | {} = isRequiredApproval
    ? {
        review: {
          type: OrderReviewType.any,
          status: OrderReviewStatus.waitingForApproval,
        },
      }
    : {};

  const order: CardOrder = {
    ...orderBase,
    transfers,
    exhibitorPairId,
    organiserRevenue,
    products: products.map((product) =>
      mapOrderProduct(product, PaymentMethodType.cardPayment)
    ),
    ...review,
    paymentDetails: {
      amount: totalAmount,
      status: OrderStatus.draft,
    },
    isQuick,
  };
  return order;
};

export default composeCardOrder;
